// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading--YeP9-","infoCard":"infoCard--XsgSs","actions":"actions--x+cJ8"};